import { COMMON, HIGH_AVAILABILITY } from './constants';

export const convertMbToGb = (mb) => {
    if (!mb || typeof mb !== 'number') return 0;
    return Math.round(mb / 1024);
};

function getDatabaseConfigDetails(catalogConfig) {
    if (catalogConfig?.databases && Array.isArray(catalogConfig?.databases)) {
        return catalogConfig?.databases.map((db) => ({
            databaseName: db?.name,
            dbCharacterSet: db?.charset,
            dbCollation: db?.collation,
        }));
    }
    return [];
}

export const formOrderObjFromCart = (data = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    return {
        entityDetails: {
            ...entityDetails,
        },

        // Application Section
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: { dataClassification: catalogConfig?.tags?.['pep-dataclassification'] },
            },
        }),
        sector: catalogConfig?.sector || null,
        region: catalogConfig?.region || null,
        environment: environmentDetails?.environment || null,
        applicationName: catalogConfig?.applicationName,
        appShortName: catalogConfig?.appShortName,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,

        // Resource Group
        resourceGroup: catalogConfig?.resourceGroup,
        isHighAvailabilityEnabled: catalogConfig?.highAvailability === true ? HIGH_AVAILABILITY.YES : HIGH_AVAILABILITY.NO,
        availabilityZone: catalogConfig?.availabilityZone,
        geoReplication: catalogConfig?.geoReplication ? COMMON.YES : COMMON.NO,
        supportedFlexibleServerEditions: catalogConfig?.supportedFlexibleServerEditions,
        skuType: catalogConfig?.skuName,
        storageSizeOption: catalogConfig?.storageMB,
        version: catalogConfig?.version,
        autoGrowEnabled: catalogConfig?.autoGrowEnabled === true ? COMMON.YES : COMMON.NO,

        // Database Configs
        databaseConfigs: getDatabaseConfigDetails(catalogConfig),

        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    return {
        entityDetails: {
            ...entityDetails,
        },
        // Application Section
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: { dataClassification: catalogConfig?.tags?.['pep-dataclassification'] },
            },
        }),
        sector: catalogConfig?.sector || null,
        region: catalogConfig?.region || null,
        environment: environmentDetails?.environment || null,
        applicationName: catalogConfig?.applicationName,
        appShortName: catalogConfig?.appShortName,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,

        // Resource Group
        resourceGroup: catalogConfig?.resourceGroup,
        isHighAvailabilityEnabled: catalogConfig?.highAvailability === true ? HIGH_AVAILABILITY.YES : HIGH_AVAILABILITY.NO,
        availabilityZone: catalogConfig?.availabilityZone,
        geoReplication: catalogConfig?.geoReplication ? COMMON.YES : COMMON.NO,
        supportedFlexibleServerEditions: catalogConfig?.supportedFlexibleServerEditions,
        skuType: catalogConfig?.skuName,
        storageSizeOption: catalogConfig?.storageMB,
        version: catalogConfig?.version,
        autoGrowEnabled: catalogConfig?.autoGrowEnabled === true ? COMMON.YES : COMMON.NO,

        // Database Configs
        databaseConfigs: getDatabaseConfigDetails(catalogConfig),

        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time cost',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'per item per month',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const resetOrder = {
    entityDetails: null,
    appProfile: null,
    appProfileDetails: null,
    sector: null,
    sectorDetail: null,
    environment: null,
    region: null,
    regionDetail: null,
    applicationName: null,
    appShortName: null,
    appOwner: null,
    appOwnerDetails: null,
    businessCategory: null,

    // Resource
    resourceGroup: null,
    resourceGroupDetail: null,
    subscription: null,
    postgreSqlServerName: null,
    supportedFlexibleServerEditions: null,
    supportedFlexibleServerEditionsDetail: null,
    skuType: null,
    skuTypeDetail: null,
    version: null,
    versionDetail: null,
    storageSizeOption: null,
    storageSizeOptionDetail: null,
    geoReplication: 'No',
    isHighAvailabilityEnabled: 'No',
    autoGrowEnabled: 'No',
    availabilityZone: null,
    availabilityZoneDetail: null,

    // DatabaseConfigurationSection
    databaseConfigs: [
        {
            databaseName: '',
            dbCharacterSet: null,
            dbCharacterSetDetail: null,
            dbCollation: null,
            isClone: false,
        },
    ],

    catalogCode: null,
    catalogType: null,
    cloudProvider: null,
    cloudService: null,
    validationStatus: null,
    isTouched: null,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
};

export const findDuplicateDatabaseConfigs = (array) => {
    const uniqueElements = new Map();
    const duplicates = new Map();

    const cleanedArray = array?.map((item) => {
        const newItem = { ...item };
        delete newItem.isClone;
        return newItem;
    });

    cleanedArray?.forEach((item, index) => {
        const jsonString = JSON.stringify(item);
        if (uniqueElements.has(jsonString)) {
            if (duplicates.has(jsonString)) {
                duplicates.get(jsonString).push(index);
            } else {
                duplicates.set(jsonString, [uniqueElements.get(jsonString), index]);
            }
        } else {
            uniqueElements.set(jsonString, index);
        }
    });

    return duplicates;
};

export const getCombinedDuplicateDatabaseIndexes = (array) => {
    const duplicates = findDuplicateDatabaseConfigs(array);
    return Array.from(duplicates.values()).flat();
};
